export enum LocationType{
    COUNTRY,
    STATE,
    COUNTY,
    TOWN,
    UNKNOWN
}